// extracted by mini-css-extract-plugin
module.exports = {"NavFooter":"NavFooter_NavFooter__34YQQ"};